import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import $ from 'jquery';
import React, { Component, useState } from 'react';
import { ApiUrl } from '../../services/ApiRest';
import "../../vicerrectoradoacad/vicerrectoradoacad.css";
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import "./hojaestilotitulacion.css";
import "./ReporteDocumentos.css";
import MensajeTipoTitulacion from './MensajeTipoTitulacion';
import TutorAsignado from './TutorAsignado';

const cookie = new Cookies();

const urlListarTiposTitulacion = ApiUrl + "listartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngresarTipoTitulacion = ApiUrl + "ingresartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlDatosTipoTitulacion = ApiUrl + "datostipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModificarTipoTitulacion = ApiUrl + "modificartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCarrAsigTipoTitu = ApiUrl + "carrerasasigtipoTitu" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInfPeriodoCarreraUltNivel = ApiUrl + "periodultnivelmatricarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCarrerasMatrUltCiclo = ApiUrl + "carrerasmatriultimociclo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlTipoTitulacionEstudiante = ApiUrl + "tipotitulacionselectestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlConsultTipoTitulacionEstudiante = ApiUrl + "consulttipotitulselectestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlReportDocumentoTitulacionEst = ApiUrl + "documentitulaciontipotitulestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCargarDocumentoEstud = ApiUrl + "documentostitulacionestudiante" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarTiposCalificacionesHab = ApiUrl + "listartipocalificacionhab" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class ListTiposTitulacion extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalDescripcionDocumento: false,
            modalObservacionDocumento: false,
            carreramatultciclo: [],
            listTiposCalificaciones: [],
            coordinacion: [],
            listaBackup: [],
            carrera: [],
            listatipostitultodos: [],
            listCarrTipoTitulMod: [],
            documentoTitulacion: [],
            ordendoclist: [],
            disableForm4: true,
            mensajeseleccion: "",
            nomtipotitulseleccionado: "",
            form: {
            },
            form1: {
            },
            form2: {
            },
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalIngresarTipoTitulacion: false });
            this.setState({ modalModTipoTitulacion: false });
            this.setState({ modalDescripcionDocumento: false });
            this.setState({ modalObservacionDocumento: false });
        }
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }


    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        $("#nomtutorasignado").hide();


        //Listar las carreras
        axios
            .post(urlCarrerasMatrUltCiclo, {
                idEstudiante: cookie.get("idEstudiante")
            })
            .then(response => {
                if (response.data.success == true)
                    this.setState({ carreramatultciclo: response.data.data });
                else {
                    this.setState({ carreramatultciclo: [] });
                    swal({
                        title: "Advertencia",
                        text: "Usted no se encuentra cursando el último ciclo de su carrera.",
                        icon: "warning",
                    })
                }
            })

    }

    //Modal de Ingreso
    modalAgregarEntidad = (registro) => {
        this.setState({ modalIngresarTipoTitulacion: true, form1: registro });
    }
    //Ocultar modal de ingreso
    ocultarModalIngresarTipoTitul = () => {
        this.setState({ modalIngresarTipoTitulacion: false });
    }

    ocultarModalModificartDatosTipoTitulacion = () => {
        this.setState({ modalModTipoTitulacion: false });
    }

    ingresarDatosTipoTitulacion = () => {
        let carreraselect = [];
        $("input:checkbox[class=checkbox-carrtipotituing]:checked").each(function () {
            var carrseleccionado = $(this).parent().parent().find('td').eq(0).text();
            let fila = {
                idCarr: carrseleccionado
            };
            carreraselect.push(fila);
        });
        var gsoncarrerasselect = JSON.stringify(carreraselect);
        axios
            .post(urlIngresarTipoTitulacion, {

                nombrett: this.state.nombretipo,
                descripciontt: this.state.descriptipo,
                estadott: 1,
                listcarreras: gsoncarrerasselect,
            })
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    axios
                        .post(urlListarTiposTitulacion, {
                            idCarreraTipoT: this.state.idCarrera
                        })
                        .then(response => {

                            listaauxiliar = response.data.data;
                            if (listaauxiliar != null) {

                                const estud = response.data.data;
                                this.setState((state) => {
                                    return { estud: estud }
                                }
                                );
                                const ListaBackup = estud;

                                this.setState((state) => {
                                    return { ListaBackup: ListaBackup }
                                });
                                //PAGINACION
                                this.setState({ itemOffset: 0 });
                                const endOffset = this.state.itemOffset + itemsPerPage;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ ListaBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                this.setState((state) => {
                                    return { itemOffset: state.itemOffset + endOffset }
                                });
                                //FIN  D DE LA PAGINACION
                            }
                            else {
                                swal({
                                    title: "Advertencia",
                                    text: "No existe información",
                                    icon: "warning",
                                })
                            }
                        })
                    this.setState({ modalIngresarTipoTitulacion: false });
                } else {
                    swal({
                        text: "Datos no actualizados",
                        icon: "error",
                        button: "Aceptar",
                    });
                    this.setState({ modalIngresarEntidad: false });
                }
            })
            .catch(error => {

                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",

                });
            });
    }
    //Modal de mostrar datos de un tipo de titulación
    mostrarModalDatosTipoTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        this.setState({ listCarrTipoTitulMod: [] });
        this.setState({ modalModTipoTitulacion: true });
    }

    mostrarDatosTipoTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios.post(urlDatosTipoTitulacion, {
            idTipoTitulacion: this.state.idtipomod,
        })
            .then(response => {
                const TipoTitulacion = response.data.data;
                $(function () {
                    $("#nombretipomod").val(TipoTitulacion[0].nom_tipo_titulacion);
                    $("#descriptipomod").val(TipoTitulacion[0].descrip_tipo_titulacion);
                    $("#idestadomod").val(TipoTitulacion[0].estado_tipo_titulacion);
                });
                this.setState({ nombretipomod: TipoTitulacion[0].nom_tipo_titulacion });
                this.setState({ descriptipomod: TipoTitulacion[0].descrip_tipo_titulacion });
                this.setState({ idestadomod: TipoTitulacion[0].estado_tipo_titulacion });
                //Lista las carreras asignadas a un tipo de titulación
                axios.post(urlListarCarrAsigTipoTitu, {
                    idTipoTitu: this.state.idtipomod
                })
                    .then(res => {
                        const listaCarrTitulacionMod = res.data.data;
                        this.setState({ listCarrTipoTitulMod: listaCarrTitulacionMod });
                    })
            })
        this.setState({ modalModTipoTitulacion: true });

    }
    ocultarModalModifCentro = () => {
        this.setState({ modalModEntidad: false });
    }
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataNom = item.nom_tipo_titulacion.toUpperCase();
            const itemDataDescrip = item.descrip_tipo_titulacion.toUpperCase();
            const campo = itemDataNom + itemDataDescrip;
            //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1

        })
        if (text == "") {
            newData = this.state.ListaBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })
    }
    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ ListaBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }
    //FINDE FUNCION DE PAGINACION

    handleChangeActPeriod = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })

        axios
            .post(urlInfPeriodoCarreraUltNivel, {
                idEstudiante: cookie.get("idEstudiante"),
                idCarrera: this.state.idCarrera,
            })
            .then(response => {

                this.setState({ descriperiodo: response.data.data[0].descripcion_periodo_academico });
                this.setState({ idperiodo: response.data.data[0].id_periodo_academico });
            })


        axios
            .post(urlConsultTipoTitulacionEstudiante, {
                idEstudiante: cookie.get("idEstudiante"),
                idCarrera: this.state.idCarrera,
            })
            .then(response => {
                if (response.data.success == true) {
                    $("#nomtutorasignado").show();
                    var mensaje = "Usted ha seleccionado el tipo de titulación: " + response.data.data[0].nom_tipo_titulacion;
                    this.setState({ idTipoTitulacion: response.data.data[0].id_tipo_titulacion });
                    var idTutor = response.data.data[0].id_administrativo;
                    var nombresTutor = response.data.data[0].nombres_administrativo + " " + response.data.data[0].apellidos_administrativo;
                    var cedulaTut = response.data.data[0].numero_identificacion_administrativo;
                    var correoTut = response.data.data[0].email_administrativo;
                    var celularTut = response.data.data[0].celular_administrativo;
                    var idTipoTitulac = response.data.data[0].id_tipo_titulacion;



                    if (idTutor == 1) {
                        this.setState({ nombrescomplettutor: "Sin asignación de tutor" });
                        this.setState({ cedulaTutor: "Sin asignación de tutor" });
                        this.setState({ correoTutor: "Sin asignación de tutor" });
                        this.setState({ celularTutor: "Sin asignación de tutor" });
                    }
                    else {

                        this.setState({ nombrescomplettutor: nombresTutor });
                        this.setState({ cedulaTutor: cedulaTut });
                        this.setState({ correoTutor: correoTut });
                        this.setState({ celularTutor: celularTut });
                    }
                    this.setState({ mensajeseleccion: mensaje });
                    this.setState({ nomtipotitulseleccionado: response.data.data[0].nom_tipo_titulacion });

                    this.setState({ currentItems: [] });
                    $("#mensajetipotitulselect").show();
                    $("#tablatipostitulacion").hide();
                    this.setState({ disableForm4: false });
                    //Reporta los documentos
                    axios.post(urlReportDocumentoTitulacionEst, {
                        idTipoTitul: idTipoTitulac,
                        idEstudiante: cookie.get("idEstudiante"),
                        idCarrera: this.state.idCarrera,
                    })
                        .then(res => {
                            const documentoTitulacion = res.data.data;
                            this.setState({ documentoTitulacion });
                        })
                    //Reporte de calificaciones
                    axios.get(urlListarTiposCalificacionesHab, {
                        params: {
                            idTipoTitulacion: idTipoTitulac,
                            idEstudiante: cookie.get("idEstudiante"),
                            idCarrera: this.state.idCarrera,
                        }
                    })
                        .then(resp => {
                            const ok = resp?.data?.success === true;
                            const lista = Array.isArray(resp?.data?.data) ? resp.data.data : [];

                            if (!ok || !lista.length) {
                                this.setState({ listTiposCalificaciones: [], notas: {}, error: "No existen tipos de calificación" });
                                swal({ text: "No existen tipos de calificación", icon: "info", button: "Aceptar" });
                                return;
                            }

                            const notas = {};
                            for (const it of lista) {
                                const pid = it.id_tipo_titulacion_tipo_calificacion;
                                notas[pid] = (it.nota === null || it.nota === undefined || it.nota === "")
                                    ? ""
                                    : Number(it.nota);
                            }

                            this.setState({
                                listTiposCalificaciones: lista,
                                notas,
                                error: null
                            });
                        })
                        .catch(error => {
                            console.error("Error al obtener los tipos de calificación:", error);
                            this.setState({ listTiposCalificaciones: [], notas: {}, error: "No se encontraron datos" });
                            swal({ text: "No se encontraron datos", icon: "error", button: "Aceptar" });
                        });
                    //fin de calificaciones
                }
                else {
                    $("#mensajetipotitulselect").hide();
                    $('#tablatipostitulacion').show();
                    this.setState({ mensajeseleccion: "" });
                    this.setState({ nomtipotitulseleccionado: "" });
                    axios
                        .post(urlListarTiposTitulacion, {
                            idCarreraTipoT: this.state.idCarrera
                        })
                        .then(response => {

                            listaauxiliar = response.data.data;
                            if (listaauxiliar != null) {
                                const estud = response.data.data;
                                this.setState((state) => {
                                    return { estud: estud }
                                }
                                );
                                const ListaBackup = estud;

                                this.setState((state) => {
                                    return { ListaBackup: ListaBackup }
                                });
                                //PAGINACION
                                this.setState({ itemOffset: 0 });
                                const endOffset = this.state.itemOffset + itemsPerPage;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ ListaBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                this.setState((state) => {
                                    return { itemOffset: state.itemOffset + endOffset }
                                });
                                //FIN  D DE LA PAGINACION
                            }
                            else {
                                swal({
                                    title: "Advertencia",
                                    text: "No existe información",
                                    icon: "warning",
                                })
                            }
                        })
                }
            })


    }
    //modificar

    modificarDatosTipoTitulacion = () => {
        let carreraselect = [];
        $("input:checkbox[class=checkbox-carrtipotitumod]:checked").each(function () {

            var carrseleccionado = $(this).parent().parent().find('td').eq(0).text();
            let fila = {
                idCarrMod: carrseleccionado
            };
            carreraselect.push(fila);
        });
        var gsoncarrerasselect = JSON.stringify(carreraselect);

        axios
            .post(urlModificarTipoTitulacion, {
                idttmod: this.state.idtipomod,
                nombrettmod: this.state.nombretipomod,
                descripcionttmod: this.state.descriptipomod,
                estadomod: this.state.idestadomod,
                listcarrerasmod: gsoncarrerasselect,
            })
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    axios
                        .post(urlListarTiposTitulacion, {
                            idCarreraTipoT: this.state.idCarrera
                        })
                        .then(response => {

                            listaauxiliar = response.data.data;
                            if (listaauxiliar != null) {

                                const estud = response.data.data;
                                this.setState((state) => {
                                    return { estud: estud }
                                }
                                );
                                const ListaBackup = estud;

                                this.setState((state) => {
                                    return { ListaBackup: ListaBackup }
                                });
                                //PAGINACION
                                this.setState({ itemOffset: 0 });
                                const endOffset = this.state.itemOffset + itemsPerPage;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ ListaBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                this.setState((state) => {
                                    return { itemOffset: state.itemOffset + endOffset }
                                });
                                //FIN  D DE LA PAGINACION
                            }

                        })
                    this.setState({ modalModTipoTitulacion: false });
                } else {
                    swal({
                        text: "Datos no actualizados",
                        icon: "error",
                        button: "Aceptar",
                    });
                    this.setState({ modalModTipoTitulacion: false });
                }
            })
            .catch(error => {

                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",

                });
            });
    }

    handleChangeTiposTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios
            .post(urlListarTiposTitulacion, {
                idCarreraTipoT: this.state.idCarrera
            })
            .then(response => {

                listaauxiliar = response.data.data;
                if (listaauxiliar != null) {
                    const estud = response.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const ListaBackup = estud;

                    this.setState((state) => {
                        return { ListaBackup: ListaBackup }
                    });
                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ ListaBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  D DE LA PAGINACION
                }
                else {
                    swal({
                        title: "Advertencia",
                        text: "No existe información",
                        icon: "warning",

                    })
                    this.setState({ currentItems: [] });
                }
            })
    }

    seleccionartipoTitulacion = (datos) => {//valido
        var combmsmalert = "Usted ha seleccionado el tipo de titulación: " + datos.nom_tipo_titulacion;
        this.setState({ idTipoTitulacion: datos.id_tipo_titulacion });

        swal({
            title: "Advertencia",
            text: combmsmalert,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios
                        .post(urlTipoTitulacionEstudiante, {
                            idEstudiante: cookie.get("idEstudiante"),
                            idTipoTitulacion: datos.id_tipo_titulacion,
                            idPeriodo: this.state.idperiodo,
                            idCarrera: this.state.idCarrera,
                        })
                        .then(response => {
                            if (response.data.success === true) {
                                swal({
                                    text: "Datos ingresados correctamente",
                                    icon: "success",
                                    button: "Aceptar",
                                });
                                //Actualizar
                                axios
                                    .post(urlConsultTipoTitulacionEstudiante, {
                                        idEstudiante: cookie.get("idEstudiante"),
                                        idCarrera: this.state.idCarrera,
                                    })
                                    .then(response => {

                                        if (response.data.success == true) {
                                            var mensaje = "Usted ha seleccionado el tipo de titulación: " + response.data.data[0].nom_tipo_titulacion;
                                            this.setState({ idTipoTitulacion: response.data.data[0].id_tipo_titulacion });
                                            var nombresTutor = response.data.data[0].nombres_administrativo + " " + response.data.data[0].apellidos_administrativo;
                                            var idTutor = response.data.data[0].id_administrativo;
                                            var cedulaTut = response.data.data[0].numero_identificacion_administrativo;
                                            var correoTut = response.data.data[0].email_administrativo;
                                            var celularTut = response.data.data[0].celular_administrativo;
                                            $("#nomtutorasignado").show();
                                            if (idTutor == null) {
                                                this.setState({ nombrescomplettutor: "Sin asignación de tutor" });
                                                this.setState({ cedulaTutor: "Sin asignación de tutor" });
                                                this.setState({ correoTutor: "Sin asignación de tutor" });
                                                this.setState({ celularTutor: "Sin asignación de tutor" });
                                            }
                                            else {

                                                this.setState({ nombrescomplettutor: nombresTutor });
                                                this.setState({ cedulaTutor: cedulaTut });
                                                this.setState({ correoTutor: correoTut });
                                                this.setState({ celularTutor: celularTut });
                                            }

                                            this.setState({ mensajeseleccion: mensaje });
                                            this.setState({ nomtipotitulseleccionado: response.data.data[0].nom_tipo_titulacion });
                                            this.setState({ currentItems: [] });
                                            $("#mensajetipotitulselect").show();
                                            $("#tablatipostitulacion").hide();
                                        }
                                        else {
                                            $("#mensajetipotitulselect").hide();
                                            $('#tablatipostitulacion').show();
                                            this.setState({ mensajeseleccion: "" });
                                            this.setState({ nomtipotitulseleccionado: "" });
                                            axios
                                                .post(urlListarTiposTitulacion, {
                                                    idCarreraTipoT: this.state.idCarrera
                                                })
                                                .then(response => {

                                                    listaauxiliar = response.data.data;
                                                    if (listaauxiliar != null) {
                                                        const estud = response.data.data;
                                                        this.setState((state) => {
                                                            return { estud: estud }
                                                        }
                                                        );
                                                        const ListaBackup = estud;

                                                        this.setState((state) => {
                                                            return { ListaBackup: ListaBackup }
                                                        });
                                                        //PAGINACION
                                                        this.setState({ itemOffset: 0 });
                                                        const endOffset = this.state.itemOffset + itemsPerPage;
                                                        this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                                        this.setState({ ListaBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                                        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                                        this.setState((state) => {
                                                            return { itemOffset: state.itemOffset + endOffset }
                                                        });
                                                        //FIN  D DE LA PAGINACION
                                                    }
                                                    else {
                                                        swal({
                                                            title: "Advertencia",
                                                            text: "No existe información",
                                                            icon: "warning",
                                                        })
                                                    }
                                                })
                                        }
                                    })
                                //fin de actualización
                            } else {
                                swal({
                                    text: "Datos no ingresados",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                            }
                        })
                        .catch(error => {
                            this.setState({ error: "No existe conexión con el servidor" });
                            swal({
                                text: "No existe conexión con el servidor",
                                icon: "error",
                                button: "Aceptar",
                            });
                        });
                } else {
                    swal({
                        text: "¡Haz denegado la acción!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    }

    handleFileChangeAndModify = (e, consola) => {
        const files = e.target.files; // Obtenemos todos los archivos seleccionados
        if (files && files.length > 0) {
            const file = files[0]; // Obtenemos el primer archivo seleccionado

            // Validación de tipo de archivo
            const allowedTypes = [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            ];

            if (!allowedTypes.includes(file.type)) {
                swal({
                    text: "El archivo debe ser de tipo PDF o Word (.doc, .docx)",
                    icon: "error",
                    button: "Aceptar",
                });
                return; // Detenemos la ejecución si el archivo no es válido
            }

            // Confirmación antes de subir
            swal({
                title: "¿Está seguro de continuar?",
                text: "Está a punto de cargar un documento. Asegúrese de que el archivo seleccionado sea el correcto antes de continuar.",
                icon: "warning",
                buttons: ["Cancelar", "Sí, subir"],
                dangerMode: true,
            }).then((willUpload) => {
                if (willUpload) {
                    const formData = new FormData();
                    formData.append("documento_titulacion_id", consola.id_documento_titulacion);
                    formData.append("estudiante_id", cookie.get("idEstudiante"));
                    formData.append("archivo", file);

                    const config = {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    };

                    // Enviar la solicitud POST con el archivo
                    axios.post(urlCargarDocumentoEstud, formData, config)
                        .then(response => {
                            if (response.data.success) {
                                swal({
                                    text: "Documento ingresado correctamente",
                                    icon: "success",
                                    button: "Aceptar",
                                });

                                // Actualizar la lista de documentos del estudiante
                                axios.post(urlReportDocumentoTitulacionEst, {
                                    idTipoTitul: this.state.idTipoTitulacion,
                                    idEstudiante: cookie.get("idEstudiante"),
                                    idCarrera: this.state.idCarrera,
                                }).then(res => {
                                    const documentoTitulacion = res.data.data;
                                    this.setState({ documentoTitulacion });
                                });

                            } else {
                                swal({
                                    text: response.data.message || "Error al cargar el documento",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                            }
                        })
                        .catch(error => {
                            console.error("Error en la solicitud:", error);
                            swal({
                                text: "No se pudo conectar con el servidor",
                                icon: "error",
                                button: "Aceptar",
                            });
                        });
                } else {
                    // El usuario canceló
                    swal({
                        text: "Subida cancelada.",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            });

        } else {
            swal({
                text: "Por favor seleccione un archivo.",
                icon: "warning",
                button: "Aceptar",
            });
        }
    };

    mostrarModalDescripDocumento = (registro) => {
        this.setState({
            modalDescripcionDocumento: true,
            descripcionDocumento: registro || ''
        });
    };
    ocultarModalDescripDocumento = () => {
        this.setState({ modalDescripcionDocumento: false });
    }

    mostrarModalObservDocumento = (registro) => {
        this.setState({
            modalObservacionDocumento: true,
            observacionDocumento: registro || ''
        });
    };
    ocultarModalObservDocumento = () => {
        this.setState({ modalObservacionDocumento: false });
    }
    //Reporte para las calificaciones
    handleNotaChange = (pivotId, value) => {
        const v = value === '' ? '' : Number(value);
        this.setState(prev => ({ notas: { ...prev.notas, [pivotId]: v } }));
    };

    getPromedio = () => {
        const { listTiposCalificaciones, notas } = this.state;
        const valores = listTiposCalificaciones
            .map(it => notas[it.id_tipo_titulacion_tipo_calificacion])
            .filter(v => typeof v === 'number' && !Number.isNaN(v));
        if (!valores.length) return '';
        const sum = valores.reduce((a, b) => a + b, 0);
        return (sum / valores.length).toFixed(2);
    };


    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{ }</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">

                    <div className="back-istmas">
                        <i className="fas fa-graduation-cap icono-animado"></i>
                        <b className="mb-0 fw-semibold"> Tipos de titulación</b>
                    </div>


                    <div className="card-body">
                        <div className="row ">
                            <div className="col-12 col-sm-12 col-lg-5 col-xl-5 centrar">
                                <div className="mb-3">
                                    <label className="form-label"><b> <i className="fa fa-calendar"></i> Carrera</b></label>
                                    <select className="form-select" name="idCarrera" value={this.state.value} onChange={this.handleChangeActPeriod} aria-label="Default select example">

                                        <option value="undefined" selected="true" disabled>Seleccione una carrera</option>
                                        {this.state.carreramatultciclo.map(person => <option key={person.id_carrera} value={person.id_carrera} > {person.descripcion_carrera} </option>)}

                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                <label className="form-label"><b> <i className="fa fa-calendar"></i> Período Académico</b></label>
                                <br />
                                <label className="form-label">
                                    {this.state.descriperiodo}
                                </label>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-12 col-sm-12 col-lg-7 col-xl-7 centrar">
                                <div className="mb-3">
                                    <MensajeTipoTitulacion tipo={this.state.nomtipotitulseleccionado} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                <div className="titulo-card-container">
                                    <TutorAsignado
                                        nombres={this.state.nombrescomplettutor}
                                        correo={this.state.correoTutor}
                                        telefono={this.state.celularTutor}
                                    />
                                </div>
                                <h3 className="titulo-card-header">Tutor</h3>

                            </div>
                        </div>
                        <div className="row " id="tablatipostitulacion">
                            <div className="p-3 rounded-3 mt-3">
                                <h6 className="fw-bold text-center mb-3 text-azul">Reporte de tipos de titulación</h6>
                                <div class="table-responsive">
                                    <table className="table table-hover table-sm-custom" >
                                        <thead className="table-light" >
                                            <tr className="text-start text-azul" >
                                                <th scope="col">Nombre</th>
                                                <th scope="col">Descripción</th>
                                                <th scope="col">Carrera</th>
                                                <th scope="col">Seleccionar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.currentItems && this.state.currentItems.map((consola) => (
                                                <tr className="text-start text-azul" key={consola.id_tipo_titulacion}>
                                                    <td class="oculto"> {consola.id_tipo_titulacion}</td>
                                                    <td >{consola.nom_tipo_titulacion}</td>
                                                    <td >{consola.descrip_tipo_titulacion}</td>
                                                    <td >{consola.descripcion_carrera}</td>
                                                    <td >
                                                        <input type="radio" value="1" name="afiliado" id="afiliado" onClick={() => this.seleccionartipoTitulacion(consola)} class="afiliado" />

                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-center mt-4 ">
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            pageCount={this.state.pageCount}
                                            onPageChange={this.handlePageClick}
                                            containerClassName="pagination pagination-sm-custom"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            activeClassName="active"
                                        />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                    <Modal isOpen={this.state.modalIngresarTipoTitulacion}>
                                        <ModalHeader>

                                            Ingresar un tipo de titulación
                                        </ModalHeader>
                                        <ModalBody class="colormodal" >
                                            <FormGroup>

                                                <label className="form-label">Nombre</label>
                                                <input type="text" id="nombretipo" name="nombretipo" className="form-control" onChange={this.handleChange} required />
                                                <label className="form-label">Descripción</label>
                                                <input type="text" id="descriptipo" name="descriptipo" className="form-control" onChange={this.handleChange} required />
                                                <label className="form-label">Seleccione la carrera a la que pertenece</label>
                                                <div class="table-responsive">
                                                    <table id="tablacarreras" className="table  text-left" >
                                                        <thead >
                                                            <tr>
                                                                <th scope="col">Carrera</th>
                                                                <th scope="col">Seleccionar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.carrera.map(consola => (
                                                                <tr key={consola.id_carrera}>
                                                                    <td class="idCarreraSelect oculto" >{consola.id_carrera}</td>
                                                                    <td class="descriCarreraSelect" >{consola.descripcion_carrera}</td>
                                                                    <td class="selectCarrera">
                                                                        <input disabled={(this.state.disablmodmat) ? "disabled" : ""} name={"checkcarr" + consola.id_carrera} id={"checkcarr" + consola.id_carrera} type="checkbox" class="checkbox-carrtipotituing" />
                                                                        {(() => {
                                                                            $('#checkcarr' + consola.id_carrera).checked = false;
                                                                        })()}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </FormGroup>
                                        </ModalBody>
                                        <ModalFooter>
                                            <button class="btn btn-outline-primary" onClick={() => this.ingresarDatosTipoTitulacion()} >Aceptar</button>
                                            <button class="btn btn-outline-primary" onClick={this.ocultarModalIngresarTipoTitul}>Salir</button>
                                        </ModalFooter>
                                    </Modal>
                                </div>


                            </div>

                        </div>
                        <div className="row  ">
                            <div className="mb-3 ">
                                <Modal classname="modal-background" isOpen={this.state.modalModTipoTitulacion}>
                                    <ModalHeader>
                                        <h5></h5>
                                        Modificar los datos del tipo de titulación
                                    </ModalHeader>
                                    <ModalBody>
                                        <FormGroup>
                                            <label className="form-label">Seleccione el nivel a cursar</label>
                                            <select className="form-select" id="idtipomod" name="idtipomod" value={this.state.value} onChange={this.mostrarDatosTipoTitulacion} aria-label="Default select example">
                                                <option value="undefined" selected="true" disabled>Seleccione el periódo</option>


                                                {this.state.listatipostitultodos.map(person => <option key={person.id_tipo_titulacion} value={person.id_tipo_titulacion} >{person.nom_tipo_titulacion}</option>)}

                                            </select>
                                            <label className="form-label">Nombre</label>
                                            <input type="text" id="nombretipomod" name="nombretipomod" className="form-control" onChange={this.handleChange} required />
                                            <label className="form-label">Descripción</label>
                                            <input type="text" id="descriptipomod" name="descriptipomod" className="form-control" onChange={this.handleChange} required />
                                            <label className="form-label">Estado</label>
                                            <select className="form-select" id="idestadomod" name="idestadomod" value={this.state.value} onChange={this.handleChange} aria-label="Default select example" disabled={(this.state.disabledformpagmodd) ? "disabled" : ""} >
                                                <option value="0" >Deshabilitado</option>
                                                <option value="1" >Habilitado</option>
                                            </select>
                                            <div className="mb-3">
                                                <label className="form-label">Seleccione el rol</label>
                                                <div class="table-responsive">
                                                    <table id="tablacarrtipomod" className="table  text-left" >
                                                        <thead >
                                                            <tr>

                                                                <th scope="col">Carrera</th>
                                                                <th scope="col">Seleccionar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.listCarrTipoTitulMod.map(consola => (
                                                                <tr key={consola.id_carrera}>
                                                                    <td class="idCarreraMod oculto">{consola.id_carrera}</td>
                                                                    <td class="decripCarreraMod" >{consola.descripcion_carr}</td>
                                                                    <td class="selectcarreraMod">
                                                                        <input name={"checkmod" + consola.id_carrera} id={"checkmod" + consola.id_carrera} type="checkbox" class="checkbox-carrtipotitumod" />
                                                                        {(() => {

                                                                            if (this.state.modalModTipoTitulacion == true) {
                                                                                if (consola.estado == 1) {
                                                                                    $(function () {
                                                                                        $('#checkmod' + consola.id_carrera)[0].checked = true;
                                                                                    })
                                                                                }
                                                                                else {
                                                                                    if (consola.estado == 0) {
                                                                                        $(function () {
                                                                                            $('#checkmod' + consola.id_carrera)[0].checked = false;
                                                                                        })
                                                                                    }

                                                                                }
                                                                            }
                                                                        })()}

                                                                    </td>
                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button class="btn btn-outline-primary" onClick={() => this.modificarDatosTipoTitulacion(this.state.form2)} > Modificar</button>
                                        <button class="btn btn-outline-primary" onClick={this.ocultarModalModificartDatosTipoTitulacion}>Salir</button>
                                    </ModalFooter>
                                </Modal>
                            </div>
                        </div>
                        <br />
                        <div className="p-3 rounded-3 mt-3">
                            <h6 className="fw-bold text-center mb-3 text-azul">Reporte de documentos</h6>
                            <div className="table-responsive">

                                <table className="table table-hover table-sm-custom" id="tablaasignaturas" name="tablaasignaturas">
                                    <thead className="table-light">
                                        <tr className="text-start text-azul">
                                            <th className="oculto">ID</th>
                                            <th>No</th>
                                            <th>Nombre</th>
                                            <th>Descripción</th>
                                            <th>Formato</th>
                                            <th>Archivo subido</th>
                                            <th>Fecha de envío</th>
                                            <th>Estado</th>
                                            <th className="oculto">CarreraTipoTitulacion</th>
                                            <th>Revisado por</th>
                                            <th>Observaciones</th>
                                            <th>Cargar Archivo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* lógica JSX de mapeo permanece igual */}
                                        {this.state.documentoTitulacion.map((consola) => (
                                            <tr className="text-start text-azul" key={consola.id_documento_titulacion}>
                                                <td class="oculto">{consola.id_documento_titulacion}</td>
                                                <td>{consola.orden_documento_id}</td>
                                                <td>{consola.nom_documento_titulacion}</td>
                                                <td>
                                                    <button
                                                        onClick={() => this.mostrarModalDescripDocumento(consola.descrip_documento_titulacion)}
                                                        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }} title="Ver descripción"
                                                    >
                                                        <i className="fa fa-2x fa-align-left text-primary" ></i>
                                                    </button>

                                                </td>
                                                <td>
                                                    {(() => {
                                                        if (consola.archivo_documento_titulacion) {
                                                            return (<a href={consola.ruta_formato} target="blank"><i class="fa fa-2x fa-file-alt text-danger" aria-hidden="true" title="Descargar el formato"></i></a>);

                                                        }
                                                    })()}
                                                </td>
                                                <td>
                                                    {(() => {
                                                        if (consola.iddocumentestud == 0) {
                                                            return  <span className="small text-muted">Pendiente</span>
                                                        }
                                                        else return (
                                                            <a href={consola.ruta_document_cargado} target="_blank" rel="noopener noreferrer" title="Descargar el archivo subido">
                                                                <i class="fa fa-2x fa-file-alt text-success" aria-hidden="true"></i>
                                                            </a>
                                                        );
                                                    })()}
                                                </td>
                                                <td>
                                                    {consola.fecha_envio}
                                                </td>

                                                <td>
                                                    {consola.estado}

                                                </td>

                                                <td class="oculto"> {consola.carrera_tipo_titulacion_id}</td>

                                                <td>{consola.descripcion_rol}</td>
                                                <td>
                                                    <button className="btn-icon-svg" onClick={() => this.mostrarModalObservDocumento(consola.observacion_documento)} title="Ver observaciones">
                                                       
                                                        <i className="fa fa-2x fa-comment text-primary"></i>
                                                    </button>
                                                </td>
                                                <td class="detalle">

                                                    {(() => {
                                                        if ((consola.id_estado == 1) || (consola.id_estado == 2)) {

                                                            return <h7 ></h7>
                                                        }
                                                        else
                                                            return (
                                                                <input

                                                                    type="file"
                                                                    accept=".pdf,.doc,.docx"
                                                                    onChange={(e) => this.handleFileChangeAndModify(e, consola)}
                                                                    className="form-control form-control-sm"
                                                                />
                                                            );

                                                    })()}


                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row  ">
                            <div className="mb-3 ">

                                {this.state.modalDescripcionDocumento && (
                                    <div className="modal-backdrop">
                                        <div className="modal-content tabla-container verde modal-descripcion">
                                            <button className="close-buttondescrip" onClick={this.ocultarModalDescripDocumento}>
                                                &times;
                                            </button>

                                            <div className="titulo-tabla">Descripción</div>

                                            <div className="contenido-descripcion">
                                                <p className="texto-justificado">{this.state.descripcionDocumento}</p>
                                            </div>

                                            <div className="footer-descripcion">

                                            </div>
                                        </div>
                                    </div>
                                )}
                                {this.state.modalObservacionDocumento && (
                                    <div className="modal-backdrop">
                                        <div className="modal-content tabla-container verde modal-descripcion">
                                            <button className="close-buttondescrip" onClick={this.ocultarModalObservDocumento}>
                                                &times;
                                            </button>

                                            <div className="titulo-tabla">Observaciones</div>

                                            <div className="contenido-descripcion">
                                                <p className="texto-justificado">{this.state.observacionDocumento}</p>
                                            </div>

                                            <div className="footer-descripcion">

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* tabla de reporte de calificaciones del estudiante*/}
                        <div className="p-3 rounded-3 mt-3">
                            <h6 className="fw-bold text-center mb-3 text-azul">Reporte de calificaciones</h6>

                            <div className="table-responsive mt-4">
                                <table className="table table-sm table-hover align-middle">
                                    <thead className="small text-center table-light">
                                        <tr className="align-middle">
                                            <th className="text-start text-azul">Calificación</th>
                                            <th className="text-start text-azul">Nota</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listTiposCalificaciones.map(item => {
                                            const pid = item.id_tipo_titulacion_tipo_calificacion;
                                            return (
                                                <tr key={pid}>
                                                    <td className="text-azul small">{item.nombre_calif_doc_titu}</td>
                                                    <td style={{ maxWidth: 140 }}>

                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            min="0"
                                                            max="20"
                                                            step="0.01"
                                                            value={this.state.notas[pid] ?? ''}
                                                            readOnly
                                                        />


                                                    </td>
                                                </tr>
                                            );
                                        })}

                                        {/* Fila de PROMEDIO (se actualiza sola) */}
                                        <tr className="table-light">
                                            <td className="text-end fw-bold">Promedio</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm fw-bold"
                                                    value={this.getPromedio()}
                                                    readOnly
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <br />
                    </div>
                </div>
            </div >
        )
    }
}

